import * as stylex from '@stylexjs/stylex';
import { createElement, forwardRef } from 'react';
import { theme } from 'trellis-theming/theme.stylex';
import { DATA_COMPONENT_ATTRIBUTE } from '../../../constants/dataAttributes';
const COMPONENT_NAME = 'Inline';
const baseStyles = {
  base: {
    display: "x78zum5",
    flexDirection: "x1q0g3np",
    flexWrap: "x1a02dak",
    $$css: true
  }
};
const spaceStyles = {
  none: {
    gap: "xxhr3t",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  "2xs": {
    gap: "x1vic7bs",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  xs: {
    gap: "xx3nbei",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  sm: {
    gap: "x1obj75",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  md: {
    gap: "xglmkbt",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  lg: {
    gap: "x19n7znh",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  xl: {
    gap: "x16a7io4",
    rowGap: null,
    columnGap: null,
    $$css: true
  }
};
const alignStyles = {
  start: {
    justifyContent: "x1nhvcw1",
    $$css: true
  },
  center: {
    justifyContent: "xl56j7k",
    $$css: true
  },
  end: {
    justifyContent: "x13a6bvl",
    $$css: true
  }
};
const verticalAlignStyles = {
  start: {
    alignItems: "x1cy8zhl",
    $$css: true
  },
  center: {
    alignItems: "x6s0dn4",
    $$css: true
  },
  end: {
    alignItems: "xuk3077",
    $$css: true
  }
};
function InlineConfigInner({
  as = 'div',
  children,
  space = 'none',
  align = 'start',
  verticalAlign = 'center',
  id,
  ariaLabel,
  ariaLabelledby,
  ariaDescribedby,
  ariaDescription,
  dataTestId,
  xstyle: __noXstyle
}, ref) {
  const styles = [baseStyles.base, alignStyles[align], verticalAlignStyles[verticalAlign], spaceStyles[space]];
  return /*#__PURE__*/createElement(as, Object.assign({
    ref,
    id: id === null || id === void 0 ? void 0 : id.root,
    'aria-label': ariaLabel === null || ariaLabel === void 0 ? void 0 : ariaLabel.root,
    'aria-labelledby': ariaLabelledby === null || ariaLabelledby === void 0 ? void 0 : ariaLabelledby.root,
    'aria-describedby': ariaDescribedby === null || ariaDescribedby === void 0 ? void 0 : ariaDescribedby.root,
    'aria-description': ariaDescription === null || ariaDescription === void 0 ? void 0 : ariaDescription.root,
    'data-test-id': dataTestId === null || dataTestId === void 0 ? void 0 : dataTestId.root
  }, stylex.props(...styles), {
    [DATA_COMPONENT_ATTRIBUTE]: COMPONENT_NAME
  }), children);
}
InlineConfigInner.displayName = 'InlineConfigInner';

/**
 * Config-layer horizontal layout. One job: a wrapping horizontal cluster with
 * equal gaps (tags, chips, button bars) — spacing owned by the parent, not the
 * children. It always wraps. Use `Columns` for non-wrapping width
 * partitions. Exposes intent props (`space`, `align`, `verticalAlign`, `as`)
 * and structured accessibility attributes.
 *
 * If the available props don't satisfy your use case, reach out in
 * #trellis-support — it directly informs how we evolve the layout components.
 */
export const Inline = /*#__PURE__*/forwardRef(InlineConfigInner);
Inline.displayName = COMPONENT_NAME;